<template>
  <Modal v-model="visible" title="关联合伙渠道" :mask-closable="false" width="500" class="my-modal min top" :footer-hide="true">
    <Form v-if="visible" ref="myForm" :model="formData" :label-width="90" class="modal-form" @submit.native.prevent>
      <loading :isShow="loading" />
      <FormItem prop="merId" label="合伙渠道" :rules="$units.formRule.required('请选择')">
        <lzSelect v-model="formData.merId" placeholder="请输入渠道名称搜索" ref="salesmanSelect" :remote-method="getMerList" @select="selectData">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.shortName">
              {{ item.shortName }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="primary" ghost @click="visible = false">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { common } from '@/api/mixins';
import lzSelect from '@/components/commons/lzSelect';
export default {
  mixins: [common],
  components: {
    lzSelect
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      merList: [],
    };
  },
  methods: {
    open(data = {}) {
      this.formData = {
        merId: '',
        policyNo: data.policyNo
      }
      this.loading = false;
      this.clearValidate();
      this.visible = true;
    },
    // 获取凤栖渠道列表
    getMerList(keyword) {
      if (!keyword) {
        return;
      }
      return this.$http({
        url: '/buz/policyDrainage/getFqyfMerchant',
        type: 'GET',
        data: {
          key: keyword
        }
      }).then(res => {
        return res.data;
      });
    },
    // 选择渠道 
    selectData(data) {
      this.formData.merchantName = data.label
    },
    save() {
      this.$refs.myForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.$http({
          url: '/buz/policyDrainage/add',
          type: 'POST',
          data: this.formData
        }).then(res => {
          this.$notice.success('操作成功');
          this.visible = false;
          this.$emit('reload');
        });
      })
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
